import React from "react";

import ContentUsuario from "./ContentUsuario";

const Usuario = () => {
  return (
    <>
      <ContentUsuario />
    </>
  );
};

export default Usuario;
